import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * The plugin's page route.
 *
 * Not optional decoration: the app's nav builds its items by walking the page
 * extensions and calling `getData(coreExtensionData.routeRef)` on each, and
 * skips any page that returns nothing. A `PageBlueprint` without a `routeRef`
 * therefore mounts and routes correctly but never appears in the sidebar.
 *
 * It also gives anything linking to the page — the home widget, for one — a
 * target that survives someone overriding `page:litellm`'s path in app-config,
 * via `useRouteRef(rootRouteRef)`.
 */
export const rootRouteRef = createRouteRef();
